import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { type ReactNode } from "react";
import { defaultRouteForRole, getSession, type Role } from "./auth";
import { LoginPage } from "./pages/LoginPage";
import { ScanPage } from "./pages/ScanPage";
import { LookupPage } from "./pages/LookupPage";
import { Layout } from "./components/Layout";

function RequireAuth({ allow, children }: { allow?: Role[]; children: ReactNode }) {
  const session = getSession();
  const location = useLocation();
  if (!session) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (allow && !allow.includes(session.role)) {
    // Authenticated but wrong role — bounce to their default landing page.
    return <Navigate to={defaultRouteForRole(session.role)} replace />;
  }
  return <>{children}</>;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/scan"
        element={
          <RequireAuth>
            <Layout>
              <ScanPage />
            </Layout>
          </RequireAuth>
        }
      />
      <Route
        path="/lookup"
        element={
          <RequireAuth allow={["admin"]}>
            <Layout>
              <LookupPage />
            </Layout>
          </RequireAuth>
        }
      />
      <Route path="*" element={<RootRedirect />} />
    </Routes>
  );
}

function RootRedirect() {
  const session = getSession();
  if (!session) return <Navigate to="/login" replace />;
  return <Navigate to={defaultRouteForRole(session.role)} replace />;
}
